<script lang="ts">
  import { AuctionStatus } from '@do/models';

  import { MousePointer } from '@shared/ui/mouse-pointer';
  import { ListLayoutMasonry, ListLayoutRelative, ListLayoutSingle } from '@shared/ui/list';
  import { LayoutType, layoutType, layoutTypeMobile } from '@shared/lib';
  import { ArtAssetCard, artAssetCardModel } from '@entities/art-asset/art-asset-card';
  import { AuctionCard, auctionCardModel } from '@entities/auction/auction-card';
  import type { ArtAssetReadManyResponse } from '@pages/artworks/types';

  export let artworks: ArtAssetReadManyResponse['artworks'];

  const displayAuctionStatuses: AuctionStatus[] = [AuctionStatus.Active, AuctionStatus.Finalizing];
</script>

<MousePointer>
  <div class="hidden overflow-visible md:block">
    {#if $layoutType === LayoutType.Masonry}
      <ListLayoutMasonry products="{artworks}" let:breakpoints let:product>
        {#key product.id}
          {#if product.auction && displayAuctionStatuses.includes(product.auction.status)}
            <AuctionCard
              id="{product.auction.id}"
              status="{product.auction.status}"
              startDate="{product.auction.start_date}"
              duration="{product.auction.duration}"
              bestBid="{product.auction.best_bid}"
              initialPrice="{product.physical_purchase_price}"
              artAsset="{auctionCardModel.mapApiArtAsset(product)}"
            />
          {:else}
            <ArtAssetCard {...artAssetCardModel.mapApiToData(product)} {breakpoints} />
          {/if}
        {/key}
      </ListLayoutMasonry>
    {:else}
      <ListLayoutRelative products="{artworks}" let:breakpoints let:product>
        {#key product.id}
          {#if product.auction && displayAuctionStatuses.includes(product.auction.status)}
            <AuctionCard
              id="{product.auction.id}"
              status="{product.auction.status}"
              startDate="{product.auction.start_date}"
              duration="{product.auction.duration}"
              bestBid="{product.auction.best_bid}"
              initialPrice="{product.physical_purchase_price}"
              artAsset="{auctionCardModel.mapApiArtAsset(product)}"
            />
          {:else}
            <ArtAssetCard {...artAssetCardModel.mapApiToData(product)} {breakpoints} />
          {/if}
        {/key}
      </ListLayoutRelative>
    {/if}
  </div>
  <div class="overflow-visible md:hidden">
    {#if $layoutTypeMobile === LayoutType.Masonry}
      <ListLayoutMasonry products="{artworks}" let:breakpoints let:product>
        {#key product.id}
          {#if product.auction && displayAuctionStatuses.includes(product.auction.status)}
            <AuctionCard
              id="{product.auction.id}"
              status="{product.auction.status}"
              startDate="{product.auction.start_date}"
              duration="{product.auction.duration}"
              bestBid="{product.auction.best_bid}"
              initialPrice="{product.physical_purchase_price}"
              artAsset="{auctionCardModel.mapApiArtAsset(product)}"
            />
          {:else}
            <ArtAssetCard {...artAssetCardModel.mapApiToData(product)} {breakpoints} />
          {/if}
        {/key}
      </ListLayoutMasonry>
    {:else}
      <ListLayoutSingle products="{artworks}" let:breakpoints let:product>
        {#key product.id}
          {#if product.auction && displayAuctionStatuses.includes(product.auction.status)}
            <AuctionCard
              id="{product.auction.id}"
              status="{product.auction.status}"
              startDate="{product.auction.start_date}"
              duration="{product.auction.duration}"
              bestBid="{product.auction.best_bid}"
              initialPrice="{product.physical_purchase_price}"
              artAsset="{auctionCardModel.mapApiArtAsset(product)}"
            />
          {:else}
            <ArtAssetCard {...artAssetCardModel.mapApiToData(product)} {breakpoints} />
          {/if}
        {/key}
      </ListLayoutSingle>
    {/if}
  </div>
</MousePointer>
